<form class="mform" [formGroup]="countryForm">
  <div class="waub_slct">
    <div class="lbl_lft">
      <label for="countryId" class="lbl_fd">Country</label>
    </div>
    <div class="lbl_rgt">
      <div class="s362">
        <span class="styled" [ngClass]="{'hght':focusFlag()}">{{countryForm.get('countryId')?.value?.countryName ||
        'Select country'}}</span>
        <svg class="drp_imgs" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="Icon-right">
            <path id="Icon" d="M15 8L10 13L5 8" stroke="#707274" stroke-width="1.67" stroke-linecap="round"
              stroke-linejoin="round" />
            </g>
          </svg>

          <mat-form-field class="soption">
            <mat-select class="slt" id="countryId" formControlName="countryId"
              (selectionChange)="getInstitutionList($event)" (focus)="focusFlag.set(true)"
              (focusout)="focusFlag.set(false)">
              <mat-option value="">Select country</mat-option>
              @for (country of countryList; track country) {
                <mat-option [value]="country">
                  {{country.countryName}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    @if (showGlobalCountry && countryForm.get('globalCountryId')) {
      <div class="waub_slct">
        <div class="lbl_lft">
          <label for="globalCountryId" class="lbl_fd">Global market</label>
        </div>
        <!-- lbl_rgt start here -->
        <div class="lbl_rgt">
          <div class="s362">
            <span class="styled" [ngClass]="{'hght':glbFocusFlag()}">{{countryForm.get('globalCountryId')?.value?.countryName
            || 'Select global market'}}</span>
            <svg class="drp_imgs" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="Icon-right">
                <path id="Icon" d="M15 8L10 13L5 8" stroke="#707274" stroke-width="1.67" stroke-linecap="round"
                  stroke-linejoin="round" />
                </g>
              </svg>
              <mat-form-field class="soption">
                <mat-select class="slt" id="globalCountryId" formControlName="globalCountryId"
                  (selectionChange)="getInstitutionList($event, 'global')" (focus)="glbFocusFlag.set(true)"
                  (focusout)="glbFocusFlag.set(false)">
                  <mat-option value="">Select global market</mat-option>
                  @for (glbCountry of globalCountryList; track glbCountry) {
                    <mat-option [value]="glbCountry">
                      {{glbCountry.countryName}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      }

      <div class="waub_slct">
        <div class="lbl_lft">
          <label for="institutionName">Institution name/ID</label>
        </div>
        <div class="lbl_rgt">
          <input type="text" class="inpt i390" matInput id="institutionId" maxLength="150" value=""
            formControlName="institutionId" [matAutocomplete]="auto"
            [ngClass]="{'sred': (selectedInstitution?.value.length && ((countryForm.get('institutionId')?.errors && !countryForm.get('institutionId')?.hasError('notFound')) || !(institutionList|searchFilter:(selectedInstitution.value):3:'institutionDisplayName').length))}"
            #selectedInstitution>
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="setInstitution(auto)">
              @for (option of (institutionList|searchFilter:(selectedInstitution.value):3:(isNumber(selectedInstitution.value)?'institutionId':'institutionName'): isNumber(selectedInstitution.value)); track $index) {
                <mat-option
                  [value]="option">
                  {{option.institutionDisplayName}}
                </mat-option>
              }
            </mat-autocomplete>
            <div class="bubbletip_venueName" name="errortips">
              @if ((countryForm.get('institutionId')?.errors && !countryForm.get('institutionId')?.hasError('notFound'))) {
                @if (countryForm.get('institutionId')?.hasError('minLength')) {
                  <span id="bubbletip_venueName_text" class="error-txt"
                    >Institution Name must be at least 3
                  characters.</span>
                }
              } @else {
                @if (!(institutionList|searchFilter:(selectedInstitution.value):3:'institutionDisplayName': isNumber(selectedInstitution.value)).length) {
                  <span id="bubbletip_venueName_text" class="error-txt"
                  >No result found. Please enter the exact ID or institution name and try again.</span>
                }
              }
            </div>
          </div>
        </div>
      </form>